/* eslint-disable react/prop-types */ // TODO: add props
import PropTypes from 'prop-types';
import { Component } from 'react';
import classNames from 'classnames';
import ImmutablePropTypes from 'react-immutable-proptypes';
import Immutable from 'immutable';
import { withAnalytics } from 'edrolo/analytics';

import Attachment from './Attachment';

@withAnalytics
class Materials extends Component {
  static defaultProps = {
    title: null,
    attachments: Immutable.List(),
    inline: false,
  };

  static propTypes = {
    title: PropTypes.string,
    attachments: ImmutablePropTypes.list,
    inline: PropTypes.bool,
  };

  render() {
    const {
      title,
      attachments,
      inline,
      analytics: { track },
    } = this.props;
    const classes = classNames('materials', {
      'list-inline': inline,
    });

    return (
      <ul className={classes}>
        {title ? <li key="title"> {title} </li> : null}
        {attachments
          .map((attachment, i) => (
            <li key={i}>
              <Attachment
                attachment={attachment}
                onClick={() => track('opened supplementary material')}
              />
            </li>
          ))
          .toList()
          .toJS()}
      </ul>
    );
  }
}

export default Materials;
